export const GETTING_STARTED_REFERRER_KEY = 'referrer' as const;
export const GETTING_STARTED_REFERRER_VALUE = 'gettingStartedPage' as const;
export const CURATE_PRIORITY_GROUPS_FOR_YOUR_TEAMS_ENGAGEMENT_ID =
	'curate-priority-groups-for-your-teams' as const;
